import { StyledFooterContainer, StyledFooterText } from '../post-room-completion-feedback-step.styles';
interface FeedbackFooterProps {
  text?: string;
}
export const FeedbackFooter = ({
  text = 'This feature is free while in beta.'
}: FeedbackFooterProps) => {
  return <StyledFooterContainer data-sentry-element="StyledFooterContainer" data-sentry-component="FeedbackFooter" data-sentry-source-file="feedback-footer.tsx">
      <StyledFooterText data-sentry-element="StyledFooterText" data-sentry-source-file="feedback-footer.tsx">{text}</StyledFooterText>
    </StyledFooterContainer>;
};